/* Cuisine Inspirante — ajout au panier depuis le panier latéral.
   Boutons [data-ci-cart-add][data-variant-id] : ajoute 1 article via /cart/add.js,
   puis rafraîchit le tiroir avec les sections renvoyées (même mécanisme que la fiche produit).
   Passe par window.fetch : compatible avec ci-gift-guard.js.
   « Nos clients aiment aussi » : rendu par le tiroir quand la liste des réglages est remplie ;
   sinon remplit [data-ci-complement] quand le tiroir est ouvert, via /recommendations/products
   (intent complementary, puis related seulement si data-related="true") et sections/ci-cart-complement.liquid. */
(function () {
  if (window.__ciCart) return;
  window.__ciCart = true;

  function addUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base.replace(/\.js$/, '') + '.js';
  }

  function reset(btn, label, text) {
    btn.removeAttribute('aria-disabled');
    if (label) label.textContent = text;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-ci-cart-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var drawer = document.querySelector('cart-drawer');
    var scope = btn.closest('.ci-ce, .ci-cx, .ci-rc') || document;
    var error = scope.querySelector('[data-ci-cart-error]');
    var label = btn.querySelector('[data-ci-label]');
    var text = label ? label.textContent : '';

    if (error) error.hidden = true;
    btn.setAttribute('aria-disabled', 'true');
    if (label && btn.dataset.loadingText) label.textContent = btn.dataset.loadingText;

    var sections = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];

    fetch(addUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, body: j }; });
      })
      .then(function (res) {
        if (!res.ok || res.body.status) throw new Error(res.body.description || 'add failed');
        if (drawer && res.body.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.body);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        reset(btn, label, text);
        if (error) error.hidden = false;
      });
  });

  /* Produit complémentaire */
  function giftIds() {
    return (window.CI_GIFT_RULES || []).map(function (r) { return String(r.gift); });
  }

  function recoUrl(productId, intent) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'recommendations/products?section_id=ci-cart-complement&limit=10&product_id=' +
      encodeURIComponent(productId) + '&intent=' + intent;
  }

  function pick(productId, intent) {
    var gifts = giftIds();
    return fetch(recoUrl(productId, intent), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var block = doc.querySelector('[data-ci-recos]');
        if (!block) return null;
        var cards = block.querySelectorAll('[data-ci-cx]');
        for (var i = 0; i < cards.length; i++) {
          var ids = (cards[i].dataset.variantIds || '').split(',');
          var isGift = ids.some(function (id) { return gifts.indexOf(id) !== -1; });
          if (isGift) cards[i].remove();
        }
        return block.querySelector('[data-ci-cx]') ? block : null;
      });
  }

  function loadComplement() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return;
    var slot = drawer.querySelector('[data-ci-complement]');
    if (!slot || slot.dataset.ciState) return;
    var productId = slot.dataset.productId;
    if (!productId) return;
    slot.dataset.ciState = 'loading';

    pick(productId, 'complementary')
      .then(function (card) {
        if (card || slot.dataset.related !== 'true') return card;
        return pick(productId, 'related');
      })
      .then(function (card) {
        if (!slot.isConnected) return;
        slot.dataset.ciState = 'done';
        if (!card) return;
        slot.innerHTML = '';
        slot.appendChild(document.importNode(card, true));
        slot.hidden = false;
      })
      .catch(function () {
        if (slot.isConnected) slot.dataset.ciState = 'done';
      });
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(loadComplement, 120);
  }

  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(schedule).observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
